/**
 * useToast Hook
 * Hook for displaying toast notifications
 *
 * @module hooks/useToast
 */

import { useCallback } from "react";

const TOAST_EVENT = "app:toast";

/**
 * Toast hook for triggering toast notifications
 * @returns {Object} Toast functions
 */
const useToast = () => {
  const showToast = useCallback((message, type = "info", duration = 5000) => {
    window.dispatchEvent(
      new CustomEvent(TOAST_EVENT, {
        detail: { message, type, duration },
      })
    );
  }, []);

  const success = useCallback((message, duration) => {
    showToast(message, "success", duration);
  }, [showToast]);

  const error = useCallback((message, duration) => {
    showToast(message, "error", duration);
  }, [showToast]);

  const warning = useCallback((message, duration) => {
    showToast(message, "warning", duration);
  }, [showToast]);

  const info = useCallback((message, duration) => {
    showToast(message, "info", duration);
  }, [showToast]);

  return {
    showToast,
    success,
    error,
    warning,
    info,
  };
};

export default useToast;

